<template>
  <div class="yuukyuu-days edit-item add-row" v-if="editingData">
    <div class="head"><b>年次有給休暇</b></div>

    <div class="data">
      <p class="pre" v-if="
        editingData.koyou_type === OptionConst.KOYOU_TYPE.PART ||
        editingData.koyou_type === OptionConst.KOYOU_TYPE.PART_MUKI
      ">
        {{ Message.NENNJI_YUUKYUU_PART }}
      </p>

      <template v-else>
        <div class="flex flex-align-center select-box-adjust">
          <p>6ヶ月間継続勤務し、引き続き勤務する場合、年</p>
          <div class="days">
            <input-text v-model="editingData.yuukyuu_days" :type="'number'" inputmode="numeric" class="small yuukyuu-input" min="0" max="20"
              :error="getError(editingData, 'yuukyuu_days')" :disabled="disabled"></input-text>
            <p class="current-data">{{ currentData?.yuukyuu_days }}</p>
          </div>
          <p class="scale">日</p>
        </div>
        <p class="pre">{{ Message.NENNJI_YUUKYUU }}</p>

        <!-- 月給社員向けの計画有給の案内 -->
        <p class="pre"
          v-if="editingData.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU || editingData.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU_MUKI">
          {{ Message.KEIKAKU_YUUKYUU }}</p>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import OptionConst from '@/const/Option';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'
import Message from "@/const/KoyouKeiyaku/Message";

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      OptionConst,
      getError,
      Message
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

.yuukyuu-input {
  margin-left: 5px;
}
</style>
